// Core
import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";

// Styles
import "./style.scss";

// Redux
import { useDispatch } from "react-redux";
import { getIndustryListForAssessmentBLrequest_ADMIN } from "../../Redux/Slices/Admin/adminSlice";
import { getCompanyType } from "../../Redux/Slices/Accessor/accessorSlice";

// Custom component
import Button from "Components/Button";
import CommonDatePicker from "Components/CommonDatePicker";
import CustomSelect from "Components/CustomSelect";

const FilterDrawer = ({
  show,
  handleClose,
  title,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  handleClear,
  handleApply,
  selectedStatus,
  setSelectedStatus,
  selectedCompany,
  setSelectedCompany,
  selectedIndustry,
  setSelectedIndustry,
}) => {
  const [industryOptions, setIndustryOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [isApplyEnabled, setIsApplyEnabled] = useState(false);

  const dispatch = useDispatch();
  const clearButtonTitleStyle = {
    color: "#1f2155",
    fontSize: "14px",
    fontWeight: "bold",
  };
  const applyButtonTitleStyle = {
    fontSize: "14px",
    fontWeight: "bold",
  };

  const statusOptions = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Inprogress" },
    { value: "3", label: "Completed" },
  ];

  useEffect(() => {
    // Check if any field has a value
    const isAnyFieldFilled =
      dateFrom ||
      dateTo ||
      selectedStatus.length > 0 ||
      selectedCompany.length > 0 ||
      selectedIndustry.length > 0;

    setIsApplyEnabled(isAnyFieldFilled);
  }, [dateFrom, dateTo, selectedStatus, selectedCompany, selectedIndustry]);

  useEffect(() => {
    getIndustryList();
    getCompanyList();
  }, []);

  // Get Company List
  const getCompanyList = () => {
    dispatch(
      getCompanyType({
        callBack: getAllCompanyList,
      })
    );
  };

  const getAllCompanyList = (companies) => {
    const companyOptions = companies.map((company) => ({
      label: company.company_type_name,
      value: company.company_type_id,
    }));
    setCompanyOptions(companyOptions);
  };

  // Get Industry List
  const getIndustryList = () => {
    dispatch(
      getIndustryListForAssessmentBLrequest_ADMIN({
        callBack: getIndustryListForAssessmentBLrequestCB_ADMIN,
      })
    );
  };

  const getIndustryListForAssessmentBLrequestCB_ADMIN = (industries) => {
    const industryOptions = industries.map((industry) => ({
      label: industry.industry_name,
      value: industry.industry_type_id,
    }));
    setIndustryOptions(industryOptions);
  };

  const handleStatusChange = (option) => {
    setSelectedStatus(option || []);
  };

  const handleCompanyChange = (option) => {
    setSelectedCompany(option || []);
  };

  const handleIndustryChange = (option) => {
    setSelectedIndustry(option || []);
  };

  const handleApplyFilters = () => {
    const formattedStatus = selectedStatus
      .map((option) => option.value)
      .join(",");

    const formattedCompany = selectedCompany
      .map((option) => option.label)
      .join(",");

    const formattedIndustry = selectedIndustry
      .map((option) => option.label)
      .join(",");

    // Call the API or handle the filter logic here with the formatted values
    handleApply(formattedStatus, formattedCompany, formattedIndustry);
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="offcanvas-title ps-3">
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="px-3">
          <div>
            <CommonDatePicker
              id="submissionDateFrom"
              name="submissionDateFrom"
              placeholder="Submission Date From"
              value={dateFrom}
              onChange={(date) => setDateFrom(date)}
            />
          </div>
          <div className="my-4">
            <CommonDatePicker
              id="submissionDateTo"
              name="submissionDateTo"
              placeholder="Submission Date To"
              value={dateTo}
              onChange={(date) => setDateTo(date)}
              minDate={dateFrom}
            />
          </div>
          <div className="my-4">
            <CustomSelect
              options={statusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              placeholder="Status"
              isMulti={true}
            />
          </div>
          <div>
            <CustomSelect
              options={companyOptions}
              value={selectedCompany}
              onChange={handleCompanyChange}
              placeholder="Company Type"
              isMulti={true}
            />
          </div>
          <div className="my-4">
            <CustomSelect
              options={industryOptions}
              value={selectedIndustry}
              onChange={handleIndustryChange}
              placeholder="Industry"
              isMulti={true}
            />
          </div>
          <div className="row">
            <div className="col-6">
              <Button
                title="Clear All"
                className="clearButton"
                modifyClassName={true}
                titleStyle={clearButtonTitleStyle}
                onClick={handleClear}
              />
            </div>
            <div className="col-6">
              <Button
                title="Apply"
                className="applyButton"
                modifyClassName={true}
                titleStyle={applyButtonTitleStyle}
                onClick={handleApplyFilters}
                disabled={!isApplyEnabled}
              />
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default FilterDrawer;
